module.exports = __webpack_public_path__ + "static/media/maintainFacility.fc18ac16.svg";